import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

import { GlobalSearch as GlobalSearchInput } from '@/components/common';

import { useEmbryoAppContext } from '../../context/EmbryoAppContext';

export const GlobalSearch = () => {
  const { filters, updateFilter } = useEmbryoAppContext();
  const [, setSearchParams] = useSearchParams();

  const handleChange = useCallback(
    (value: string) => {
      updateFilter('searchTerm', value || undefined);
      setSearchParams(
        (prev) => {
          if (value) {
            prev.set('search', value);
          } else {
            prev.delete('search');
          }
          return prev;
        },
        { replace: true },
      );
    },
    [updateFilter, setSearchParams],
  );

  return (
    <GlobalSearchInput
      value={filters.searchTerm ?? ''}
      onChange={handleChange}
      placeholder="Search every column..."
    />
  );
};
